import { uniq } from "lodash";

import { api } from "api";

export class RouteTags {
  constructor(private selected: string[], private countries: string[]) {
    this.selected = selected;
    this.countries = countries;
  }

  // Public Methods

  async get() {
    try {
      if (this.selected.length > 0) {
        return Promise.resolve(this.selected);
      }

      const places = await api.places.listByCountries(this.countries);
      const tags = uniq(places.map((place) => place.tags).flat(1));
      const blacklist = ["Campings", "Hotels"];

      const countedTags = tags
        .map((tag) => {
          const count = places.reduce((counter, item) => {
            return item.tags.includes(tag) ? counter + 1 : counter;
          }, 0);

          return { tag, count };
        })
        .sort((a, b) => {
          return b.count - a.count;
        })
        .filter((item) => !blacklist.includes(item.tag));

      return Promise.resolve(countedTags.slice(0, 7).map((item) => item.tag));
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
